export enum UpsertServiceActiveStep {
    Detail = 'Detail',
    Pricing = 'Pricing',
    Options = 'Options',
}
